export enum FilterDialogType {
    Unknown = 0,
    Text = 1,
    ContactFilter = 2,
    ProductFilter = 3
}
